import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';
import { authenticatedUser } from 'header-scripts';

import "../../../css/forgotCredentials/forgotCredentials.scss";

// Don't bootstrap angular and just redirect to home if U13
if (authenticatedUser && authenticatedUser.isUnder13) {
    window.location.href = Roblox.EnvironmentUrls.websiteUrl + '/home';
}

//import main module definition.
import forgotCredentialsModule from './forgotCredentialsModule';

importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./directives/", true, /\.js$/));

let templateContext = require.context("./", true, /\.html$/);
let templates = templateCacheGenerator(angular, 'forgotCredentialsAppTemplates', templateContext);

//self manual initialization
const containerElement =
    document.getElementById("forgot-credentials-container") || document.getElementById("forgot-credentials-web-app");
containerElement.setAttribute('forgot-credentials', '');

angular.element(function () {
    angular.bootstrap(containerElement, [forgotCredentialsModule.name, templates.name]);
});

export default forgotCredentialsModule;